// The proxy actions, as plain functions.
//
// These used to be two one-item submenus: "Proxy Person" opened a flyout
// containing a single "Create Proxy" button, which is two hovers and a click to
// do what one click does. TGCLOUD-1644 made both rows direct, so the logic moved
// out of the components and the components went away.

const getPerson = (x) => {
  if (!x) return undefined;
  if (x?.pid) return x;
  if (x?.data?.pid) return x.data;
  return undefined;
};

/**
 * Create a proxy for `node`, anchored to whichever relationship it can be drawn
 * against.
 *
 * TGCLOUD-1597 — a proxy can stand in for a DONOR relationship as well as a
 * marriage. An identified donor is a real member, so without this their donor
 * line runs right across the pedigree with no way to shorten it. Spouse is
 * preferred when the person has both, matching the precedence in deriveProxies.
 */
export const createProxyFor = ({
  node,
  memberRecords,
  onAddProxy,
  setError
}) => {
  const menuPerson = getPerson(node);
  if (!menuPerson?.pid) {
    setError?.('Create Proxy failed: selected node pid missing.');
    return false;
  }

  const original = (memberRecords || []).find((p) => p.pid === menuPerson.pid);
  const spouseIds = Array.isArray(original?.spouseIds)
    ? original.spouseIds
    : [];
  const donorOfPids = Array.isArray(original?.donorOfPids)
    ? original.donorOfPids
    : [];

  const anchorPid = spouseIds.length
    ? spouseIds[spouseIds.length - 1]
    : donorOfPids[donorOfPids.length - 1];

  if (anchorPid == null) {
    setError?.(
      'Create Proxy: selected node has no spouse or donor relationship to proxy against.'
    );
    return false;
  }

  onAddProxy?.({ originalPid: original.pid, proxyId: anchorPid });
  return true;
};

/** Remove the proxy `node` stands in for. */
export const removeProxyFor = ({ node, onRemoveProxy, setError }) => {
  const menuPerson = getPerson(node);
  const originalPid = menuPerson?.proxyOf;
  const proxyId = (menuPerson?.spouseIds || [])[0];

  if (originalPid == null || proxyId == null) {
    setError?.('Remove Proxy: proxy is missing required references.');
    return false;
  }

  onRemoveProxy?.({ originalPid, proxyId });
  return true;
};
